import { render } from "./ContractDataCityOSGeneration.vue?vue&type=template&id=7f20bc7e&scoped=true"
import script from "./ContractDataCityOSGeneration.vue?vue&type=script&lang=js"
export * from "./ContractDataCityOSGeneration.vue?vue&type=script&lang=js"

import "./ContractDataCityOSGeneration.vue?vue&type=style&index=0&id=7f20bc7e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f20bc7e"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput});
